/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Photo_MissingInputs */

const en_us2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the photos is missing. Send both the front and the side one.`)
};

const pt_br2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faltou uma das fotos. Envie a de frente e a de lado.`)
};

const es_419_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta una de las fotos. Envía la de frente y la de lado.`)
};

const pt_pt2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falta uma das fotografias. Envia a de frente e a de lado.`)
};

const fr_fr2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il manque une des photos. Envoie celle de face et celle de profil.`)
};

const de_de2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eines der Fotos fehlt. Sende das von vorn und das von der Seite.`)
};

const it_it2_body_assessment_photo_missing = /** @type {(inputs: Body_Assessment_Photo_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manca una delle foto. Invia sia quella frontale sia quella laterale.`)
};

/**
* | output |
* | --- |
* | "One of the photos is missing. Send both the front and the side one." |
*
* @param {Body_Assessment_Photo_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_photo_missing = /** @type {((inputs?: Body_Assessment_Photo_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Photo_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_photo_missing(inputs)
	if (locale === "es-419") return es_419_body_assessment_photo_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_photo_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_photo_missing(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_photo_missing(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_photo_missing(inputs)
	return en_us2_body_assessment_photo_missing(inputs)
});
export { body_assessment_photo_missing as "body_assessment.photo_missing" }